module.exports = __webpack_public_path__ + "static/logo-2020-c532fd59711a3804899ac01a92926517.svg";